import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default from 'react';
import PropTypes__default from 'prop-types';
import { makeStyles, Box, Container, Grid, Typography } from '@material-ui/core';
import Testimonial from './Testimonial.js';

var useStyles = makeStyles(function (theme) {
  return {
    root: _defineProperty({
      padding: theme.spacing(10, 0)
    }, theme.breakpoints.down("sm"), {
      paddingTop: theme.spacing(7.5),
      paddingBottom: theme.spacing(4.5),
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1)
    }),
    bgColor: {
      background: "#F2F8FC"
    },
    mb4: {
      marginBottom: theme.spacing(4)
    },
    titleMb: _defineProperty({
      marginBottom: theme.spacing(5)
    }, theme.breakpoints.down("xs"), {
      marginBottom: theme.spacing(4)
    })
  };
});
var Testimonials = function Testimonials(_ref) {
  var title = _ref.title,
    testimonials = _ref.testimonials,
    blogStyle = _ref.blogStyle,
    bgColor = _ref.bgColor;
  var classes = useStyles();
  return /*#__PURE__*/React__default.createElement(Box, {
    bgcolor: bgColor,
    className: blogStyle ? classes.root : classes.mb4
  }, /*#__PURE__*/React__default.createElement(Container, {
    maxWidth: "lg"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    direction: "column"
  }, title && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    className: classes.titleMb
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h1",
    component: "h2",
    align: "center"
  }, title)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    direction: "row",
    justify: "center",
    spacing: 2
  }, (testimonials === null || testimonials === void 0 ? void 0 : testimonials.length) > 0 && (testimonials === null || testimonials === void 0 ? void 0 : testimonials.map(function (testimonial, index) {
    var _testimonial$image, _testimonial$image2;
    return /*#__PURE__*/React__default.createElement(Grid, {
      key: index,
      item: true
    }, /*#__PURE__*/React__default.createElement(Testimonial, {
      text: testimonial === null || testimonial === void 0 ? void 0 : testimonial.testimonialText,
      country: testimonial === null || testimonial === void 0 ? void 0 : testimonial.testimonialCountry,
      person: testimonial === null || testimonial === void 0 ? void 0 : testimonial.testimonialPerson,
      imageTitle: testimonial === null || testimonial === void 0 || (_testimonial$image = testimonial.image) === null || _testimonial$image === void 0 ? void 0 : _testimonial$image.title,
      imageUrl: testimonial === null || testimonial === void 0 || (_testimonial$image2 = testimonial.image) === null || _testimonial$image2 === void 0 ? void 0 : _testimonial$image2.url,
      icon: testimonial === null || testimonial === void 0 ? void 0 : testimonial.icon
    }));
  })))))));
};
Testimonials.propTypes = {
  testimonials: PropTypes__default.arrayOf(PropTypes__default.shape({
    testimonialText: PropTypes__default.string,
    country: PropTypes__default.string,
    person: PropTypes__default.string,
    image: PropTypes__default.shape({
      url: PropTypes__default.string
    })
  })),
  title: PropTypes__default.string,
  blogStyle: PropTypes__default.bool,
  bgColor: PropTypes__default.string
};

export { Testimonials as default };
//# sourceMappingURL=Testimonials.js.map
